<template>
  <div style="height:140px;width:100%;">
    <v-chart
      :forceFit="true" 
      :height="140" 
      :data="pieData" 
      :scale="pieScale" 
      padding="auto"
    >
      <v-tooltip :showTitle="false" dataKey="item*percent" />
      <v-pie position="percent" color="item" :vStyle="pieStyle" />
      <v-coord type="theta" :innerRadius="0.6" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  name: 'PieChart',
  components: {},
  props: {
    infoData: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      pieData: null,

      pieScale: [{
        dataKey: 'percent',
        min: 0,
        formatter: '.0%'
      }],            
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      }
    }
  },
  watch: {
    infoData: function (newVal) {
      if (newVal.length) {
        this.pieData = this.getPieData(newVal)
      }      
    }
  },
  computed: {},
  methods: {
    getPieData(sourceData) {
      const dv = new DataSet.View().source(sourceData)
      dv.transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      })
      return dv.rows
    }
  }
}
</script>

<style>
</style>
